import { serializeError } from '@/store/utils/serialize-error';
import { BrandliveEvent } from '@/types/projects.types';
import loadWorkingProjectWithIndexedDBReducerHelper from '../helpers/load-working-project-with-indexed-db-reducer-helper';
import { ProjectStateReducerCreator } from '../types';
import { RootState } from '@/store/root-state';

const loadWorkingProjectWithIndexedDBReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async (
      {
        project,
        projectUuid,
        resetValues,
        withCache = true,
      }: { project: BrandliveEvent | null; projectUuid?: string; resetValues?: boolean; withCache?: boolean },
      { rejectWithValue, getState }
    ) => {
      try {
        let _project = project;

        const rootState = getState() as RootState;

        if (rootState.project.loadingWorkingProject) return null;

        const result = await loadWorkingProjectWithIndexedDBReducerHelper({
          project,
          projectUuid,
          resetValues,
          withCache,
          getState,
        });
        if (result) {
          _project = result;
        }

        return _project;
      } catch (error) {
        console.error(error);
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        if (action.payload) {
          state.workingProject = action.payload;
        }
        state.loadingWorkingProject = false;
      },
      pending: (state) => {
        state.loadingWorkingProject = true;
      },
      rejected: (state) => {
        state.loadingWorkingProject = false;
      },
    }
  );
};

export default loadWorkingProjectWithIndexedDBReducer;
